const imageCache = new Map();

function loadImage(url) {
  if (!url) return Promise.resolve(null);

  const cached = imageCache.get(url);
  if (cached instanceof HTMLImageElement && cached.complete && cached.naturalWidth > 0) {
    return Promise.resolve(cached);
  }
  if (cached instanceof Promise) return cached;

  const promise = new Promise((resolve, reject) => {
    const el = new Image();
    el.crossOrigin = 'anonymous';
    el.onload = () => {
      imageCache.set(url, el);
      resolve(el);
    };
    el.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    el.src = url;
  });

  imageCache.set(url, promise);
  return promise;
}

export function getLoadedImage(url) {
  if (!url) return null;
  const img = imageCache.get(url);
  return img instanceof HTMLImageElement && img.complete && img.naturalWidth > 0 ? img : null;
}

export function loadLadderAssets(assets = {}) {
  const urls = [
    assets.bg,
    assets.pointerImg,
    assets.prizeImg,
    ...(assets.playerImgs || []),
  ].filter(Boolean);

  return Promise.all(urls.map(loadImage));
}